import { useInsertBlock } from "../../hooks/use-insert-block";
import type { Block, BlockType } from "../../types";
import { DroppableInsertButton } from "./droppable-insert-button";


export function InsertBlockButton({
	section,
	index,
  outset,
  isLast,
}: {
	section: "before" | "inside" | "after";
	index: number;
  outset?: boolean;
  isLast?: boolean;
}) {
	const { insertBlock } = useInsertBlock();

	const handleInsert = <T extends BlockType>(blockType: T) => {
		const properties: Record<string, unknown> = {};

		const newBlock: Block<T> = {
			type: blockType,
			alignment: "center",
			properties,
		} as Block<T>;
		insertBlock(section, index, newBlock);
	};

	const handleBlockDrop = (blockType: BlockType) => {
		handleInsert(blockType);
	};

	return (
		<div className="relative">
			<div className="absolute w-full h-[10px] -top-[14px] left-0 pointer-events-none" style={{
        top: isLast ? 0 : outset ? -20 : -14,
      }}>
				<DroppableInsertButton
					section={section}
					index={index}
					onBlockDrop={handleBlockDrop}
				>
					<div className="relative flex py-2 h-full w-full" />
				</DroppableInsertButton>
			</div>
		</div>
	);
}
